import styled from "styled-components";

import { RadioButton } from "@similarweb/ui-components";

export const StyledEnrichmentLevelRadioButton = styled(RadioButton)`
    padding: 0;
`;
